import Agencies from './agencies';
export default Agencies;